export class ProductBarCodeDto {
  barcodeType: string | undefined;
  barcodeSubtype: string;
  barcodeExpression: string;
  id?: string;

  constructor(d?: ProductBarCodeDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
